import ContractNotes from './ContractNotes.vue';

export default ContractNotes;
